module.exports = __webpack_public_path__ + "static/img/shuiZhongNewList.34b1491.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/shuiZhongNewList.jpg
// module id = ig45
// module chunks = 0